/**
 * hush-bar.js -- Hush weekend sticky bar logic.
 * No external requests, no third-party libs.
 * End timestamp and threshold are read from data-attributes on #hush-bar.
 */
(function () {
  "use strict";

  var SESSION_KEY = "hush_bar_dismissed";
  var ANNOUNCE_INTERVAL_MS = 60000; // aria-live update cap -- once per minute

  function init() {
    var bar = document.getElementById("hush-bar");
    if (!bar) return;

    // Respect session dismiss
    if (sessionStorage.getItem(SESSION_KEY) === "1") {
      bar.hidden = true;
      return;
    }

    var endIso = bar.dataset.end; // "2026-10-04T23:59:00-06:00"
    var threshold = parseInt(bar.dataset.threshold, 10); // 7500 cents
    var endMs = new Date(endIso).getTime();

    var countdown = document.getElementById("hush-countdown");
    var offer = document.getElementById("hush-offer");
    var closed = document.getElementById("hush-closed");
    var progressWrap = document.getElementById("hush-progress-wrap");
    var progressFill = document.getElementById("hush-progress-fill");
    var progressLabel = document.getElementById("hush-progress-label");
    var progressBar = progressWrap ? progressWrap.querySelector("[role=progressbar]") : null;
    var dismissBtn = document.getElementById("hush-dismiss");

    // ------------------------------------------------------------------
    // Dismiss
    // ------------------------------------------------------------------
    if (dismissBtn) {
      dismissBtn.addEventListener("click", function () {
        bar.hidden = true;
        try { sessionStorage.setItem(SESSION_KEY, "1"); } catch (e) {}
      });
    }

    // ------------------------------------------------------------------
    // Countdown
    // ------------------------------------------------------------------
    var lastAnnouncedMinute = -1;

    function formatTwo(n) {
      return n < 10 ? "0" + n : "" + n;
    }

    function updateCountdown() {
      var now = Date.now();
      var remaining = endMs - now;

      if (remaining <= 0) {
        // Sale closed
        if (countdown) countdown.textContent = "00:00:00";
        if (offer) offer.hidden = true;
        if (closed) closed.hidden = false;
        if (progressWrap) progressWrap.hidden = true;
        return; // stop ticking
      }

      var totalSec = Math.floor(remaining / 1000);
      var hours = Math.floor(totalSec / 3600);
      var minutes = Math.floor((totalSec % 3600) / 60);
      var seconds = totalSec % 60;

      var display = formatTwo(hours) + ":" + formatTwo(minutes) + ":" + formatTwo(seconds);

      if (countdown) {
        countdown.textContent = display;
        // Only update aria-label when the minute changes to avoid per-second announcements
        if (minutes !== lastAnnouncedMinute) {
          countdown.setAttribute(
            "aria-label",
            hours + " hours " + minutes + " minutes remaining"
          );
          lastAnnouncedMinute = minutes;
        }
      }

      setTimeout(updateCountdown, 1000);
    }

    updateCountdown();

    // ------------------------------------------------------------------
    // Cart progress
    // ------------------------------------------------------------------
    function formatDollars(cents) {
      var whole = Math.floor(cents / 100);
      var frac = cents % 100;
      return "$" + whole + "." + (frac < 10 ? "0" + frac : frac);
    }

    function updateProgress(totalCents) {
      if (!progressWrap) return;
      var pct = Math.min(100, Math.round((totalCents / threshold) * 100));
      if (progressFill) progressFill.style.width = pct + "%";
      if (progressBar) progressBar.setAttribute("aria-valuenow", totalCents);

      if (totalCents >= threshold) {
        if (progressLabel) {
          progressLabel.textContent =
            "Unlocked -- free shipping + a Founding Legend gift on this order";
        }
        if (progressFill) progressFill.classList.add("hush-bar__progress-fill--unlocked");
      } else {
        var remaining = threshold - totalCents;
        if (progressLabel) {
          progressLabel.textContent =
            "You are " + formatDollars(remaining) + " away from free shipping + a Founding Legend gift";
        }
        if (progressFill) progressFill.classList.remove("hush-bar__progress-fill--unlocked");
      }
    }

    // Seed from liquid-rendered value
    var initialCents = parseInt(bar.dataset.cartTotal || "0", 10);
    updateProgress(initialCents);

    // Re-fetch on cart updates (Shopify fires "cart:updated" or we poll /cart.js)
    function fetchCartAndUpdate() {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", "/cart.js", true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          try {
            var data = JSON.parse(xhr.responseText);
            updateProgress(data.total_price || 0);
          } catch (e) {}
        }
      };
      xhr.send();
    }

    // Listen for Shopify cart:updated custom event
    document.addEventListener("cart:updated", fetchCartAndUpdate);

    // Also listen for Shopify's section render / fetch cart after add-to-cart forms submit
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (form && form.action && form.action.indexOf("/cart/add") !== -1) {
        setTimeout(fetchCartAndUpdate, 600);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

